var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairSpokeGuards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,6.57c-14.21,0-25.76,11.56-25.76,25.76s11.56,25.76,25.76,25.76,25.76-11.56,25.76-25.76S46.21,6.57,32,6.57Zm0,48.52c-12.55,0-22.76-10.21-22.76-22.76S19.45,9.57,32,9.57s22.76,10.21,22.76,22.76-10.21,22.76-22.76,22.76Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,14.44c-9.87,0-17.9,8.03-17.9,17.9s8.03,17.9,17.9,17.9,17.9-8.03,17.9-17.9S41.87,14.44,32,14.44Zm0,32.8c-8.21,0-14.9-6.68-14.9-14.9s6.68-14.9,14.9-14.9,14.9,6.68,14.9,14.9-6.68,14.9-14.9,14.9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,24.72c-4.2,0-7.62,3.42-7.62,7.62s3.42,7.62,7.62,7.62,7.62-3.42,7.62-7.62-3.42-7.62-7.62-7.62Zm0,12.23c-2.54,0-4.62-2.07-4.62-4.62s2.07-4.62,4.62-4.62,4.62,2.07,4.62,4.62-2.07,4.62-4.62,4.62Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairSpokeGuards);
export default __webpack_public_path__ + "static/media/wheelchair_spoke_guards.5b34dfd7.svg";
export { ForwardRef as ReactComponent };